import src from "IMAGE";
export default { src, width: 933, height: 171, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AHx8fHqUl5+mnaO0w8XFxeS+vr7+xsbG/sPDw/64uLjiYGsXIgdeRMUAAAAASUVORK5CYII="};
